import React from "react";
import PDFViewer from "./pdfview";
const ContentViewDob = (props) => {
   const { ftype = "", title, url } = props;
   const addDefaultSrc = (e) => {
      e.target.src = "/assets/images/newimages/default-thumb.svg";
   };
   const isSmallDevices = ftype?.includes("pdf");
   if (ftype === "item" || ftype === "text") {
      return (
         <div className={` container-text-content-dob `}>
            <pre
               style={{
                  whiteSpace: "pre-wrap",
                  fontFamily: "inherit",
                  fontSize: "inherit",
                  paddingLeft: "30px",
                  paddingRight: "30px",
               }}
            >
               {title}
            </pre>
         </div>
      );
   } else if (isSmallDevices) {
      return (
         <div className="container-text-content-dob ">
            <PDFViewer pdfFile={url} />
         </div>
      );
   } else if (ftype.includes("image")) {
      return (
         <div className="flex-center h-80 w-100">
            <div style={{ width: "100%", height: "100%" }}>
               <img
                  style={{ objectFit: "contain", width: "100%", height: "100%" }}
                  src={url}
                  alt=""
                  onError={addDefaultSrc}
               />
            </div>
         </div>
      );
   } else if (ftype?.includes("video")) {
      return (
         <div className="w-100 h-100">
            <video width="100%" height="100%" controls src={url} />
         </div>
      );
   } else if (ftype?.includes("application")) {
      return (
         <embed
            width="100%"
            height="100%"
            src={`${url}#zoom=0&scrollbar=0&#toolbar=0&navpanes=0` + "#toolbar=0"}
            onContextMenu={(e) => e.preventDefault()}
            style={{ zIndex: "9" }}
         />
      );
   } else if (ftype?.includes("audio")) {
      return (
         <>
            <div style={{ padding: "30px", width: "100%" }}>
               <audio
                  src={url}
                  width="100%"
                  controls
                  controlsList="nodownload"
                  className="full-width-audio-dob-verify"
               />
            </div>
         </>
      );
   } else {
      return (
         <img
            className={`w-100 `}
            src={url}
            onError={addDefaultSrc}
            width="100%"
            height="100%"
            alt=""
            style={{
               objectFit: "contain",
            }}
         />
      );
   }
};

export default ContentViewDob;
